import {
  Box,
  ButtonBase,
  ButtonBaseProps,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ChevronDownIcon from "@/app/assets/icons/chevron-down.svg?react";
import { SUPPORTED_LANGUAGES } from "@/constants";

interface Props {
  Container?: React.FC<ButtonBaseProps>;
}

const langs = SUPPORTED_LANGUAGES

export const LangSwitcher: React.FC<Props> = ({ Container = ButtonBase }) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChangeLang = (lang: string) => {
    if (lang !== i18n.language) {
      i18n.changeLanguage(lang);
      localStorage.setItem("lang", lang);
      document.documentElement.lang = lang;
      window.location.reload();
    }
    handleClose();
  };

  const currentLang = langs.find((el) => el.value == i18n.language) || langs[0];

  return (
    <Box>
      <Container
        id="lang-btn"
        onClick={handleClick}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{
          background: "#E6F1FF",
          px: 1.5,
          py: 1.25,
          borderRadius: "6px",
          borderBottom: "2px solid rgba(21, 85, 252, 0.2)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography color="rgba(11, 19, 112, 1)" fontWeight={500}>
            {currentLang.name}
          </Typography>

          <Box component={ChevronDownIcon} />
        </Stack>
      </Container>
      <Menu
        id="lang-menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{
          mt: "2px",
        }}
        open={open}
        MenuListProps={{
          "aria-labelledby": "lang-btn",
        }}
      >
        {langs.map((lng) => (
          <MenuItem
            key={lng.value}
            onClick={() => onChangeLang(lng.value)}
            sx={{
              fontWeight: lng.value === i18n.language ? 600 : 400,
            }}
          >
            {lng.title}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
